import { connect } from 'react-redux';
import { closeAlert } from '../../reducers/alert.reducers';
import AlertDialog from './alert-dialog';

const mapStateToProps = state => ({
  open: state.alert.open,
  title: state.alert.title,
  message: state.alert.message,
});

const mapDispatchToProps = dispatch => ({
  onAgree: () => dispatch(closeAlert(true)),
  onDismiss: () => dispatch(closeAlert(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertDialog);
